import React from "react"
import avatar from "avatar/klaus-sad.svg"

const KlausSad = props => <img src={avatar} className="avatar" {...props} />

export default KlausSad
